export default "__VITE_ASSET__7659c96b__"